import React from 'react'
import { matchPath, Route as RouterRoute, Switch, useLocation } from 'react-router-dom'
import { withProfiler } from '@sentry/react'
import RouteDebugger from './Util/RouteDebugger'
import AuthSsoLoginCallbackHandler from './Auth/AuthSsoLoginCallbackHandler'
import AuthSsoLogoutCallbackHandler from './Auth/AuthSsoLogoutCallbackHandler'
import Layout from './Layout'
import AuthLoginCallbackHandler from './Auth/AuthLoginCallbackHandler'
import AuthLogoutCallbackHandler from './Auth/AuthLogoutCallbackHandler'

const routes = [
    {
        path: '/logout/callback',
        exact: true,
        strict: false,
        component: AuthLogoutCallbackHandler,
    },
    {
        path: '/login/callback',
        exact: true,
        strict: false,
        component: AuthLoginCallbackHandler,
    },
    {
        path: '/login/sso/callback/:status(success|failed)',
        exact: true,
        strict: false,
        component: AuthSsoLoginCallbackHandler,
    },
    {
        path: '/logout/sso/callback/:status(success|failed)',
        exact: true,
        strict: false,
        component: AuthSsoLogoutCallbackHandler,
    },
]

const AppRouter = () => {
    const location = useLocation()

    const isAppRouterPath = routes.find((route) => matchPath(location.pathname, {
        path: route.path,
        exact: true,
        strict: false
    }))

    if (isAppRouterPath) {
        return (
            <RouteDebugger enabled={true}>
                <Switch>
                    {routes.map((route) => (
                        <RouterRoute key={route.path} {...route} />
                    ))}
                </Switch>
            </RouteDebugger>
        )
    }

    return <Layout />
}

export default withProfiler(AppRouter, { name: 'AppRouter' })
